import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { nocModeSelector } from '@store/noc/base/selectors';
import { NOC_MODE_TRENDS } from '@utils/constants';
import { filterSelector } from '@store/noc/trendsData/selectors';
import FilterLabel from '@components/common/FilterLabel';
import { ScopeWrapper, WrapHeaderTitle, Delimiter } from '../../styled';
import { useDetectError } from '@components/noc-metric-panel/useDetectError';
import FilterError from '@components/noc-metric-panel/FilterError';
import { useInvalidDimensionCheck } from '@src/utils/filter/useInvalidDimensionCheck';

interface IProps {
  setShowFilterPanel: any;
}

export const ErrorIcon = styled.span`
  font-size: 25px;
  background-color: #f6f6f6;
  height: 36px;
  display: inline-block;
  line-height: 35px;
`;

// eslint-disable-next-line react/display-name
export default (props: IProps) => {
  const { setShowFilterPanel } = props;
  const mode = useSelector(nocModeSelector);
  const filter = useSelector(filterSelector);
  const { error } = useDetectError();
  const invalidDimensionWarning = useInvalidDimensionCheck()(filter.rule, {
    style: {
      fontSize: 18,
      marginLeft: 4,
    },
  });

  const filterNameTokens = (filter?.name || '').split(/__/);
  const filterName = filterNameTokens.map((filterNameToken, index) => {
    if (['OR', 'AND'].includes(filterNameToken)) {
      return <Delimiter key={index}>{filterNameToken}</Delimiter>;
    }
    return filterNameToken;
  });

  const wrapLine = filterNameTokens.join(' ').length < 60;

  const onNocFilterTitleClickHandler = () => {
    setShowFilterPanel(true);
  };

  return mode === NOC_MODE_TRENDS ? (
    <ScopeWrapper>
      {wrapLine ? (
        <FilterLabel
          tagColor="#BD10E0"
          text={filterNameTokens.join(' ')}
          onClick={onNocFilterTitleClickHandler}
        />
      ) : (
        <WrapHeaderTitle>
          <h2>
            <span className="noc-title-holder" role="button" onClick={onNocFilterTitleClickHandler}>
              <span className="vertical-bar" />
              <span className="noc-title">{filterName}</span>
            </span>
          </h2>
        </WrapHeaderTitle>
      )}
      {error.filter[filter?.name] && (
        <ErrorIcon>
          <FilterError />
        </ErrorIcon>
      )}
      {/* Check filter rules whether has invalid custom tag, only occurs in Video */}
      {invalidDimensionWarning}
    </ScopeWrapper>
  ) : null;
};
